const water = '#e5e5e5'
const white = '#ffffff'
const landscape = '#fbfbfb'
const text = '#acacac'
const roads = '#f5f5f5'
const buildings = '#ffffff'
const parks = '#f6f6f6'
const icons = '#c2c2c2'

export default [
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: water }, { lightness: 0 }],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [{ color: landscape }, { lightness: 0 }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{ color: roads }, { lightness: 0 }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{ color: roads }, { lightness: 0 }, { weight: 0.2 }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{ color: roads }, { lightness: 0 }],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [{ color: roads }, { lightness: 0 }],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{ color: landscape }, { lightness: 0 }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: parks }, { lightness: 21 }],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [{ color: parks }, { visibility: 'off' }],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [{ saturation: 36 }, { color: text }, { lightness: 0 }],
  },
  {
    elementType: 'labels.icon',
    stylers: [{ color: icons }, { visibility: 'on' }],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{ color: roads }, { lightness: 0 }],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [{ color: buildings }, { lightness: 0 }],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{ color: buildings }, { lightness: 0 }, { weight: 1.2 }],
  },
]
